import Loader from "./Loader";
import { useLoader } from "../context/LoaderContext";

export default function GlobalLoader() {
  const { isLoading } = useLoader();

  if (!isLoading) return null;

  return (
    <div className="loader-fullscreen" role="status" aria-live="assertive">
      <Loader size="large" variant="primary" label="Chargement" />
    </div>
  );
}
